import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	.desktop-box {
		position: relative;
		width: 100%;
		border: 0.1em solid #000000;
		background-color: #ffffff;
		margin-top: 2em;

		display: flex;
		flex-direction: column;
	}

	.title-row {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 1em;
		padding: 1em 2em;
		border-bottom: 0.1em solid #000000;

		.title {
			font-size: 1.6em;
			font-weight: 700;
		}

		.controls {
			display: flex;
			justify-content: flex-end;
			align-items: center;
			gap: 1em;
			flex-shrink: 0;

			.layout-button {
				.button {
					padding: 0;
				}
			}
		}
	}

	.body-row {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.mobile-box {
		display: none;
	}

	.image-container {
		position: relative;
		width: 20%;
		min-height: 10.5em;
		overflow: hidden;
		padding: 1em;
		display: flex;
		justify-content: center;
		align-items: center;

		.offer-image {
			object-fit: scale-down;
		}
	}

	.content-container {
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: flex-start;
		padding: 2em;
		border-left: 0.1em solid #000000;

		.content-header {
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.title {
				width: 50%;
				font-size: 1.1em;
				font-weight: 700;
			}

			.controls {
				display: flex;
				justify-content: space-between;
				align-items: center;
				gap: 1em;

				.layout-button {
					.button {
						padding: 0;
					}
				}
			}
		}

		.content-description {
			width: 100%;
			display: flex;
			gap: 0 2em;
			justify-content: space-between;
			align-items: center;
			padding-top: 0em;

			.description {
				width: 70%;

				.subtitle {
					font-size: 1em;
					font-weight: 700;
					padding-top: 1em;
				}

				.description-box-alone {
					padding: 1em 0 0 0;
				}

				.company-description {
					padding-top: 1em;
					display: inline;
					margin-right: 0.4em;
				}

				.company-site-button {
					text-decoration: underline;
					max-width: max-content;
					display: inline;
					cursor: pointer;
				}
			}

			.control {
				align-self: flex-start;
			}
			.phone-btn {
				margin-top: 1em;

				.button {
					width: 100%;
					display: flex;

					.hover-container {
						width: 100%;
					}
				}
			}
		}
	}

	&:hover {
		.offer-header {
			.offer-name {
				text-decoration: underline;
			}
		}
	}

	@media all and (max-width: ${vars.mobileL}) {
		border: none;
		border-top: 0.1em solid #000000;
		display: flex;
		flex-flow: row wrap;

		.desktop-box {
			display: none;
		}

		.mobile-box {
			display: block;
			min-width: 100%;
		}

		.content-container {
			padding: 0;
			border-left: 0;

			.content-header {
				display: flex;
				flex-flow: column wrap;
				align-items: flex-start;
				padding: 2em;

				.title-job-name {
					width: 100%;
					font-size: 1.6em;
				}
				.salary {
					font-size: 1.1em;
					justify-content: left;
				}
			}

			.content-description {
				padding: 0;
				border-top: 0.09em solid ${vars.colorBorder};

				.image-container {
					border-right: 0.09em solid ${vars.colorBorder};
					width: 30%;
					padding: 1em;
				}

				.description {
					display: flex;
					justify-content: flex-start;
					align-items: center;
					padding: 1em;
					min-width: 70%;
					min-height: 100%;
					overflow: hidden;
				}
			}
		}
	}
`;
